import { Link } from 'react-router-dom';

export function TrialBanner({ daysLeft }: { daysLeft: number }) {
  return (
    <div
      style={{
        background: 'var(--brand-dark)',
        color: 'rgba(255,255,255,0.92)',
        fontSize: 13,
        fontWeight: 500,
        padding: '9px 16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 12,
      }}
    >
      <span>
        {daysLeft <= 0
          ? 'Your free trial expires today.'
          : `Free trial: ${daysLeft} day${daysLeft === 1 ? '' : 's'} remaining.`}
      </span>
      <Link to="/subscribe" style={{ color: '#fff', fontWeight: 700, textDecoration: 'underline' }}>
        Subscribe
      </Link>
    </div>
  );
}
